import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { useStringsContext } from '../../../../contexts/strings';
import { AvailableInPortrait, AvailableWithoutPayment } from '../types';

const { REACT_APP_SPORTOMEDIA_BASE_URL } = process.env;

export const useFotbollPlayValidate = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { strings } = useStringsContext();

  const fetchAvailableInPortrait = useCallback(
    async (videoId: string, league: string): Promise<AvailableInPortrait | null> => {
      let data: AvailableInPortrait | null = null;

      try {
        const url = `${REACT_APP_SPORTOMEDIA_BASE_URL}/fotbollplay/isAvailableInPortrait/${league}?id=${videoId}`;

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Validate isAvailableInPortrait failed! (${response.status})`);
        }
        data = await response.json();
      } catch (error) {
        console.error(error);
        enqueueSnackbar(strings.messages.validateError, {
          variant: 'error',
        });
        throw error;
      }

      return data;
    },
    [enqueueSnackbar, strings]
  );

  const fetchAvailableWithoutPayment = useCallback(
    async (videoId: string, league: string): Promise<AvailableWithoutPayment | null> => {
      let data: AvailableWithoutPayment | null = null;

      try {
        const url = `${REACT_APP_SPORTOMEDIA_BASE_URL}/fotbollplay/isAvailableWithoutPayment/${league}?id=${videoId}`;

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Validate isAvailableWithoutPayment failed! (${response.status})`);
        }
        data = await response.json();
      } catch (error) {
        console.error(error);
        enqueueSnackbar(strings.messages.validateError, {
          variant: 'error',
        });
        throw error;
      }

      return data;
    },
    [enqueueSnackbar, strings]
  );

  return {
    fetchAvailableInPortrait,
    fetchAvailableWithoutPayment,
  };
};
